var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNoCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "103px",
    height: "71px",
    viewBox: "0 0 103 71",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tarjetas_perfil_empty",
    transform: "translate(-1117.000000, -517.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(1120.000000, 520.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#D8D8D8",
    strokeWidth: 5,
    x: 0,
    y: 0,
    width: 97,
    height: 65,
    rx: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0703125,
    y1: 16.5,
    x2: 94,
    y2: 16.5,
    id: "Path-10",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3.0703125,
    y1: 24.5,
    x2: 94,
    y2: 24.5,
    id: "Path-10-Copy-4",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.5292969,
    y1: 48,
    x2: 67,
    y2: 48,
    id: "Path-10-Copy-5",
    stroke: "#979797",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#979797",
    cx: 73.5,
    cy: 47.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    fill: "#979797",
    cx: 80.5,
    cy: 47.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-6",
    fill: "#979797",
    cx: 87.5,
    cy: 47.5,
    r: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoCreditCard);
export default __webpack_public_path__ + "static/media/ic_no_credit_card.803e2a1a9537483229bac9e68b0a4188.svg";
export { ForwardRef as ReactComponent };